import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'

/**
 * Empty State Component
 * Display when there's no data to show
 */
export function EmptyState({
  title = 'No data',
  description,
  icon,
  action,
  actionLabel,
  onAction,
  ...props
}) {
  return (
    <Box
      textAlign="center"
      py={ 10 }
      px={ 6 }
      { ...props }
    >
      <VStack spacing={ 4 }>
        {icon && (
          <Box fontSize="4xl" color="text.tertiary">
            { icon }
          </Box>
        )}

        <Heading size="md" color="text.primary">
          { title }
        </Heading>

        {description && (
          <Text color="text.secondary" maxW="md">
            { description }
          </Text>
        )}

        {action || (onAction && actionLabel && (
          <Button onClick={ onAction } variant="solid" size="md" mt={ 2 }>
            { actionLabel }
          </Button>
        ))}
      </VStack>
    </Box>
  )
}

export default EmptyState
